export const colors = {
  primary: '#773cd4',
  secondary: '#34a3d3',
  tertiary: '#33cccc',
  error: '#f6526a',
  text: '#0c1b28',
  white: '#ffffff',
  light: '#efefef',
  gray: '#9DA9AE'
}
